@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.checklist-remove-row {
  height: 42px;
  display: flex;
  align-items: center;
  padding: 0 3px;

  .remove-text {
    font-size: 14px;
  }

  .icon {
    height: 14px;
    width: 14px;
    padding: 7px;
    &.disabled {
      fill: @remove-all-filters-dropdown-menu-item--disabled--fill-color;
    }
  }
}
